import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, LOGO } from "../lib/api";
import { useSiteContent } from "../context/SiteContentContext";
import { Avatar } from "../components/Avatar";
import { Button } from "@/components/ui/button";
import { PawPrint, MessageCircle, UserPlus, Crown, Loader2, Flag } from "lucide-react";

export default function Welcome() {
  const navigate = useNavigate();
  const { content } = useSiteContent();
  const [owner, setOwner] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => { api.get("/owner").then(({ data }) => setOwner(data)).catch(() => {}).finally(() => setLoading(false)); }, []);

  const paras = (content.about_owner_body || "").split(/\n\n+/).filter(Boolean);

  return (
    <div className="max-w-2xl mx-auto">
      <img src={content.logo_url || LOGO} alt="Spotter" className="mx-auto w-64 mb-4" />
      <div className="bg-white border-4 border-black rounded-2xl p-6 brand-shadow text-center">
        <div className="flex items-center justify-center gap-2 text-spotter-maroon font-display text-2xl font-bold mb-3" data-testid="about-owner-title"><Crown className="w-6 h-6" style={{ color: "#E19C00" }} />{content.about_owner_title}</div>
        {owner && (
          <div className="flex flex-col items-center gap-2 mb-4">
            <Avatar user={owner} size="xl" showPresence className={owner.profile_frame ? "my-6" : ""} />
            <div className="font-heading text-xl font-bold">{owner.name}</div>
            <div className="text-sm text-spotter-maroon">@{owner.username}</div>
          </div>
        )}
        <div data-testid="about-owner-body">
          {paras.map((p, i) => <p key={i} className="text-[15px] leading-relaxed text-left mt-3 first:mt-0">{p}</p>)}
        </div>
        {content.reporting_policy && (
          <div className="mt-4 text-left text-sm text-spotter-maroon bg-spotter-cream border-2 border-black rounded-xl p-3 flex gap-2" data-testid="reporting-policy">
            <Flag className="w-4 h-4 shrink-0 mt-0.5" style={{ color: "#E19C00" }} />
            <span>{content.reporting_policy}</span>
          </div>
        )}
        {content.community_rule && (
          <div className="mt-4 text-left bg-white border-2 border-black rounded-xl p-4" data-testid="community-rule">
            {content.community_rule.split(/\n+/).filter(Boolean).map((line, i) => (
              i === 0
                ? <div key={i} className="font-display text-lg font-bold text-spotter-maroon text-center mb-2">{line}</div>
                : <p key={i} className="text-[15px] leading-relaxed text-spotter-maroon mt-2">{line}</p>
            ))}
          </div>
        )}
        <div className="flex flex-wrap gap-3 justify-center mt-5">
          {loading && <Loader2 className="w-6 h-6 animate-spin text-spotter-maroon" />}
          {owner && <Button data-testid="welcome-view-profile" onClick={() => navigate(`/profile/${owner.id}`)} className="bg-spotter-maroon text-spotter-cream border-2 border-black gap-2"><PawPrint className="w-4 h-4" />Visit my profile</Button>}
          {owner && <Button data-testid="welcome-message" onClick={() => navigate(`/messages/${owner.id}`)} variant="outline" className="border-2 border-black gap-2 bg-white"><MessageCircle className="w-4 h-4" />Message me</Button>}
          <Button data-testid="welcome-contact-admin" onClick={() => navigate("/help")} variant="outline" className="border-2 border-black gap-2 bg-white"><UserPlus className="w-4 h-4" />Contact Admin</Button>
        </div>
      </div>
    </div>
  );
}
